














































import Vue, { PropOptions } from 'vue';
import { TableHeader } from '../STable.interface';
import STableHeaderItem from './STableHeaderItem.vue';

export interface HeaderProps {
  indeterminate: boolean;
  allVModel: any;
  checkBoxLabel: string;
}

export default Vue.extend({
  name: 'STableHeader',
  components: {
    STableHeaderItem,
  },
  props: {
    showCheckboxes: { type: Boolean, default: false },
    shouldShowTableRows: { type: Boolean },
    headerProps: { type: Object } as PropOptions<HeaderProps>,
    headers: { type: Array } as PropOptions<TableHeader[]>,
    computedPagination: { type: Object },
    loading: { type: Boolean },
    fixWidths: { type: Boolean, default: true },
    dense: { type: Boolean, default: false },
  },
  data(): any {
    return {
      headerWidths: {},
    };
  },
  computed: {
    /**
     * returns true if any of the header items have a 'unit' set
     */
    showUnit(): boolean {
      return this.headers.some((h) => h.unit);
    },
  },
  watch: {
    loading() {
      if (!this.fixWidths || this.loading) return;
      this.headerWidths = {};
      this.$nextTick(() => {
        const th = Array.from((this.$refs.thead as Element).querySelectorAll('th[data-key]'));
        this.headerWidths = th.reduce((ret, element) => ({
          ...ret,
          [element.getAttribute('data-key') as string]: element.getBoundingClientRect().width,
        }), {});
      });
    },
  },
  methods: {
    getHeaderClassName(header: TableHeader): any[] {
      const customClasses = header.classNames || ([] as string[]);
      return ['s-table__header', ...customClasses];
    },
    /**
     * Is used to reduce column width jumping when loading a new page
     * NOTE: Only used for when dynamicData is set to true
     */
    getHeaderStyles(header: TableHeader) {
      if (!this.loading || !this.dynamicData) return {};
      const value = this.headerWidths[header.key];
      if (value == null) return {};
      return {
        width: `${this.headerWidths[header.key]}px`,
      };
    },
    canColumnBeSorted(header: TableHeader) {
      return header.sortable !== false;
    },
  },
});
